// src/components/Header/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo_swatch_stack_512.png'
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">
            <img height="60px" src={logo} alt="PaintFinder logo" />
            <span className="logo-text">PaintFinder</span>
          </Link>

          <div className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              Home
            </Link>
            <Link 
              to="/random-palette" 
              className={`nav-link ${location.pathname === '/random-palette' ? 'active' : ''}`}
            >
              Random Palette
            </Link>
            <Link 
              to="/how-it-works" 
              className={`nav-link ${location.pathname === '/how-it-works' ? 'active' : ''}`}
            >
              How It Works
            </Link>
            <Link
              to="/visualizer"
              className={`nav-link nav-link-highlight ${location.pathname === '/visualizer' ? 'active' : ''}`}
            >
              AI Visualizer <span className="beta-tag">Beta</span>
            </Link>
          </div>

          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`menu-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`menu-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`menu-bar ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;